import React, { useState } from "react";
import "./Contact.css";
import HeadingContact from "../../Assets/Image/HeadingContact.jpg";
import axios from "axios";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";


export default function Contact() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  
  function sendMessages() {
    return axios
      .post("https://vehex-production.up.railway.app/message/addMessage", {
        name: name,          
        email: email,        
        description: message     
      })
      .then((response) => {
        if(response.data.message==="Message Sent successfully"){
          Swal.fire({
            icon: "success",
            text: "Message Sent successfully!",
            confirmButtonText: "OK",
          });
      
         
        }
        console.log("Message sent successfully:", response);

        return response;
      })
      .catch((error) => {
        console.error("Error sending message:", error);
        return error;
      });
  }
  
 
  return (
    <>
                                    <Helmet>
                      <title>Contact</title>
                    </Helmet>
      <div className="contact">
        <div className="w-100">
          <img
            src={HeadingContact}
            alt="HeadingContact"
            height={600}
            className="w-100"
          />
        </div>
        <div className="container bg-main-color py-5 px-3 position-relative">
          <div className="d-flex flex-wrap  justify-content-between gap-5">
            <div className="flex-fill rounded-2 contactBox bg-white p-3 text-center">
              <div className=" mb-3 d-flex justify-content-center gap-2 align-items-center">
                <i class="fa-solid fa-phone fs-6 main-color "></i>
                <p className="main-color fs-5 fw-500  m-0">CALL US</p>
              </div>
              <p className="m-0 fs-5">+966506330295</p>
            </div>
            <div className="flex-fill rounded-2 contactBox bg-white p-3 text-center">
              <div className=" mb-3 d-flex justify-content-center gap-2 align-items-center">
                <i class="fa-solid fa-location-dot fs-6 main-color "></i>
                <p className="main-color fs-5 fw-500  m-0">LOCATION</p>
              </div>
              <p className="m-0 fs-5">Obhur Al-Shamaliyah, Jeddah, Saudi Arabia 
              </p>
            </div>
            <div className="flex-fill rounded-2 contactBox bg-white p-3 text-center">
              <div className=" mb-3 d-flex justify-content-center gap-2 align-items-center">
                <i class="fa-solid fa-clock fs-6 main-color "></i>
                <p className="main-color fs-5 fw-500  m-0">BUSINESS HOURS</p>
              </div>
              <p className="m-0 fs-5">8:00-5:00</p>
            </div>
          </div>

          <div className="contactForm py-3">
            <form
              class="form-control mt-4 py-4 d-flex gap-2 "
              id="register-form"
            >
              <div class="left w-50">
                <label for="Name" className="fs-5 main-color" id="name">
                  Name :
                </label>
                <input
                  type="text"
                  class="form-control py-2 mt-2 mb-3"
                  id="Namee"
                  name="Name"
                  placeholder="Enter Your Name"
                  onChange={(e) => setName(e.target.value)}
                />

                <label for="Email" className="fs-5 main-color" id="emaill">
                  Email :
                </label>
                <input
                  type="email"
                  class="form-control py-2 mt-2 mb-3"
                  id="Email"
                  name="Email"
                  placeholder="Enter your Email"
                  onChange={(e) => setEmail(e.target.value)}
                />
              </div>
              <div class="right w-50">
                <label for="Message" className="fs-5 main-color" id="messagee">
                  Message :
                </label>
                <textarea
                  type="text"
                  class="form-control py-2 mt-2 mb-3"
                  cols="15"
                  rows="5"
                  id="Message"
                  name="Message"
                  placeholder="Your Message"
                  onChange={(e) => setMessage(e.target.value)}
                ></textarea>
                <button
                  type="button"
                  class="rounded-2 transition bg-main-color text-white w-50 m-auto"
                  onClick={()=>sendMessages()}
                >Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
